import { cx } from "@/utils";
import { Link } from "./clickable";

export function Text({ className, ...props }) {
  return (
    <p
      data-slot="text"
      {...props}
      className={cx("text-base/6 text-zinc-600 sm:text-sm/6", className)}
    />
  );
}
export function TextLink({ className, ...props }) {
  return (
    <Link
      {...props}
      className={cx(
        className,
        "text-zinc-950 underline decoration-zinc-950/50 data-[hover]:decoration-zinc-950",
      )}
    />
  );
}
export function Strong({ className, ...props }) {
  return (
    <strong {...props} className={cx(className, "font-medium text-zinc-950")} />
  );
}
export function Code({ className, ...props }) {
  return (
    <code
      {...props}
      className={cx(
        className,
        "rounded border border-zinc-950/10 bg-zinc-950/[2.5%] px-0.5 text-sm font-medium text-zinc-950 sm:text-[0.8125rem]",
      )}
    />
  );
}
